import { showModal, closeModal } from './ageGate.js';

const AGE_VERIFICATION_KEY = 'ageVerified';
const AGE_VERIFICATION_DURATION = 14 * 24 * 60 * 60 * 1000;

/**
 * Sets the age verification timestamp in localStorage.
 */
function setAgeVerification() {
	const expirationDate = new Date().getTime() + AGE_VERIFICATION_DURATION;
	localStorage.setItem(AGE_VERIFICATION_KEY, expirationDate.toString());
}

/**
 * Checks if the user has verified their age within the verification duration.
 *
 * @returns {boolean} True if the user has verified their age within the duration, otherwise false.
 */
function hasVerifiedAge() {
	const expirationDate = localStorage.getItem(AGE_VERIFICATION_KEY);
	if (!expirationDate) return false;

	const currentDate = new Date().getTime();
	return currentDate < parseInt(expirationDate, 10);
}

/**
 * Handles the age verification process.
 */
function handleAgeVerification() {
	if (!hasVerifiedAge()) {
		const ageGateModal = document.querySelector('.js-modal--gate');
		if (ageGateModal) {
			showModal(ageGateModal);
			const closeButton = ageGateModal.querySelector('.js-modal__close');
			closeButton.addEventListener('click', () => {
				setAgeVerification();
				closeModal(ageGateModal);
			});
		}
	}
}

// Initialise age verification check when the DOM is fully loaded.
document.addEventListener('DOMContentLoaded', handleAgeVerification);
